import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, CardView, rem, Spacer } from 'design-system';
import { IconSettings } from 'design-system/icons/IconSettings';
import useIsTablet from 'hooks/useIsTablet';
import OverviewAddButton from '../../overview/OverviewAddButton';
import OverviewPayButton from '../../overview/OverviewPayButton';
// replica of the overview buttons row in the remove-pay-tab experience. On
// phones the row is flexed across the full width (no last-synced date); on
// tablets the buttons keep their natural width. The highlighted button is
// lifted in a white pill; the others are invisible and only reserve their
// real space.
const WalkthroughOverviewButtonsRow = ({ highlight, onPillPosition, }) => {
    const isTablet = useIsTablet();
    const reportPillPosition = (inset) => (event) => {
        const { x, width } = event.nativeEvent.layout;
        onPillPosition?.(inset + x + width / 2);
    };
    if (isTablet) {
        return (<>
        <Spacer h={4}/>
        <View style={styles.hugContainer} pointerEvents="none">
          <Spacer w={12}/>
          {highlight === 'add' ? (<View onLayout={reportPillPosition(rem(16))}>
              <CardView noMargin style={styles.card}>
                <OverviewAddButton />
              </CardView>
            </View>) : (<>
              <View style={styles.hidden}>
                <OverviewAddButton />
              </View>
              <Spacer w={8}/>
              <View onLayout={reportPillPosition(rem(16))}>
                <CardView noMargin style={styles.card}>
                  <OverviewPayButton />
                </CardView>
              </View>
            </>)}
        </View>
      </>);
    }
    return (<View style={styles.container} pointerEvents="none">
      {highlight === 'add' ? (<View style={styles.flex} onLayout={reportPillPosition(rem(32))}>
          <CardView noMargin style={styles.card}>
            <OverviewAddButton flex/>
          </CardView>
        </View>) : (<View style={[styles.flex, styles.hidden]}>
          <OverviewAddButton flex/>
        </View>)}
      {highlight === 'pay' ? (<View style={styles.flex} onLayout={reportPillPosition(rem(32))}>
          <CardView noMargin style={styles.card}>
            <OverviewPayButton flex/>
          </CardView>
        </View>) : (<View style={[styles.flex, styles.hidden]}>
          <OverviewPayButton flex/>
        </View>)}
      {/* sync is flexed, so an empty flex view reserves the same space */}
      <View style={styles.flex}/>
      <View style={styles.hidden}>
        <Button brandBorder cards title="" leftIcon={<IconSettings width={16} height={16}/>} containerStyle={styles.settings} leftIconContainerStyle={styles.settingsLeftIcon}/>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    // the row sits 16 inside the overview card, which is itself 16 from the
    // screen edge
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(8),
        marginHorizontal: rem(32),
        marginTop: rem(8),
    },
    // matches the original v6 add button replica geometry
    hugContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: rem(16),
        marginTop: rem(12),
    },
    flex: {
        flex: 1,
    },
    hidden: {
        opacity: 0,
    },
    card: {
        padding: rem(4),
        borderRadius: rem(12),
    },
    settings: {
        paddingHorizontal: rem(6),
        paddingVertical: rem(6),
    },
    settingsLeftIcon: {
        paddingRight: 0,
    },
});
export default WalkthroughOverviewButtonsRow;
